import * as contest from './actions';
import {ContestState, JsonContestItem} from './types';
import {ActionType, getType} from 'typesafe-actions';
import {Middleware} from 'redux';
import environment from "../environment";

export const fetchContestItemsMiddleware: Middleware<{}, ContestState> = ({getState}) => next => async (action: ActionType<typeof contest>) => {
  next(action);

  if (action.type != getType(contest.updateContest)) {
    return;
  }

  next(contest.fetchContestItem.request());
  try {
    const response = await fetch(`${environment.getHost()}/api/contests/v1/${action.payload}`);
    const jsonContest: JsonContestItem = await response.json();
    next(contest.fetchContestItem.success(jsonContest));
  } catch (e) {
    next(contest.fetchContestItem.failure(e));
  }
};
